import { render, staticRenderFns } from "./MedicationUsageReport.vue?vue&type=template&id=4238e876&scoped=true&"
import script from "./MedicationUsageReport.vue?vue&type=script&lang=js&"
export * from "./MedicationUsageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238e876",
  null
  
)

export default component.exports